import React,{ useEffect } from "react";
// import React, { Component } from "react";
import style from "./style.module.css"
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
// class Home extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//     };
//   }
//   componentDidMount = async () => {
//     const isAuthenticated = Cookies.get("id");
//     const navigate = useNavigate();
  
//     if (!isAuthenticated) {
//       navigate("/");
//     }
  
//   };
  

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = Cookies.get("id");
    if (!isAuthenticated) {
      navigate("/");
    }
  }, [navigate]);

  // render() {
    return (
      <>
        <div style={{padding:"0"}}>
          <div className={style.home}>
            <div>
            <h1 className={style.title}>Amaan Connector</h1>
            <h2 className={style.subtitle}>Connect you to success</h2>
            </div>
         
          </div>
        </div>


      </>
    );
  // }
};
export default Home;
